import {
    IS_LOGIN_LOADING,
    LOGIN_HAS_ERROR,
    LOGIN_FETCH_DATA_SUCCESS,
    INITIAL_LOGIN_COMPLETED,
    UPDATE_USER_TOKEN,
    UPDATE_USER_PROFILE,
    GAMING_HUB_LOADED
} from './../constants/action-types';

const initialState = {
    isLoginLoading: false,
    loginHasError: false,
    loginResponse: null,
    initialLoginCompleted: false,
    userToken: false,
    userProfile: false,
    isGamingHubLoaded: false
};
export default function authData(state = initialState, action) {
    switch (action.type) {
        case IS_LOGIN_LOADING: {
            return { ...state, isLoginLoading: action.payload };
        }
        case LOGIN_HAS_ERROR: {
            return { ...state, loginHasError: action.payload };
        }
        case LOGIN_FETCH_DATA_SUCCESS: {
            return { ...state, loginResponse: action.payload };
        }
        case INITIAL_LOGIN_COMPLETED: {
            return { ...state, initialLoginCompleted: action.payload };
        }
        case UPDATE_USER_TOKEN: {
            return { ...state, userToken: action.payload };
        }
        case UPDATE_USER_PROFILE: {
            return { ...state, userProfile: action.payload };
        }

        case GAMING_HUB_LOADED: {
            return { ...state, isGamingHubLoaded: action.payload };
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/AuthReducer.js